import { render, staticRenderFns } from "./InfeventsInfo.vue?vue&type=template&id=0b3db92a&scoped=true"
import script from "./InfeventsInfo.vue?vue&type=script&lang=js"
export * from "./InfeventsInfo.vue?vue&type=script&lang=js"
import style0 from "./InfeventsInfo.vue?vue&type=style&index=0&id=0b3db92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3db92a",
  null
  
)

export default component.exports